export const wallpapers = {
  pricing: {
    png: "/images/wallpapers/surreal.png",
    webp: "/images/wallpapers/surreal.webp",
  },
  useCases: {
    png: "/images/wallpapers/staircase.png",
    webp: "/images/wallpapers/staircase.webp",
  },
  integration: {
    png: "/images/wallpapers/library.png",
    webp: "/images/wallpapers/library.webp",
  },
} as const;
